import {mapActions, mapGetters, mapMutations} from 'vuex'
import swal from "sweetalert2";
import CONSTANTS from "@/store/constants";
import FORM_LABELS from "@/store/FormLabels";
import ShowErrors from "@/components/Payments/ShowErrors";
import ValidateAmountDecimals from "@/components/Payments/ValidateAmountDecimals";
import moment from "moment"
import api from "../api";



export default {
    name: "PaymentFormsMixin",
    data() {
      return {
          FORM_LABELS: FORM_LABELS,
          isInvoiceAmountInvalid: false,
          isTaxAmountInvalid: false,
          invoiceItems: [],
          maximumAmountCharLength: CONSTANTS.MAXIMUM_AMOUNT_CHAR_LENGTH,
          showAttachmentsError: false,
          creditMemoToolTip: FORM_LABELS.CREDIT_MEMO_TOOLTIP,
          invoiceDateToolTip: FORM_LABELS.INVOICE_DATE_TOOLTIP,
          copiedInvoiceData : {},
          supplierAutoCompleteObject: {}
      }
    },
    components: {ShowErrors, ValidateAmountDecimals},
    computed: {
        ...mapGetters(["isLoading", "isInvalidPoNumber","currentUser","userData","draftId","errorMessage","poBasedPaymentData","nonPOPaymentData","oneTimeSupplierPayment","adminDataList","advPOBasedPayment"]),
        currentFormName() {
        let currentRoute = this.$router.currentRoute.name
          return CONSTANTS.FORM_ROUTE_MAP.find(data => data.currentForm === currentRoute).formName
        },
        isFormEligibleForBankDropDown() {
            return this.$route.name === CONSTANTS.PO_BASED_PAYMENT_FORM ||
                this.$route.name === CONSTANTS.NON_PO_PAYMENT_FORM ||
                this.$route.name === CONSTANTS.DRAFT_PO_BASED_PAYMENT_FORM ||
                this.$route.name === CONSTANTS.DRAFT_NON_PO_BASED_PAYMENT_FORM ||
                this.$route.name === CONSTANTS.ADV_PO_BASED_PAYMENT_FORM ||
                this.$route.name === CONSTANTS.COPY_NON_PO_BASED_PAYMENT_FORM ||
                this.$route.name === CONSTANTS.COPY_PO_BASED_PAYMENT_FORM
        },
        isFormEligibleForDraftRequest(){
            return this.$route.name === CONSTANTS.PO_BASED_PAYMENT_FORM ||
                this.$route.name === CONSTANTS.NON_PO_PAYMENT_FORM ||
                this.$route.name === CONSTANTS.DRAFT_PO_BASED_PAYMENT_FORM ||
                this.$route.name === CONSTANTS.DRAFT_NON_PO_BASED_PAYMENT_FORM ||
                this.$route.name === CONSTANTS.COPY_NON_PO_BASED_PAYMENT_FORM ||
                this.$route.name === CONSTANTS.COPY_PO_BASED_PAYMENT_FORM ||
                this.$route.name === CONSTANTS.ONE_TIME_SUPPLIER_PAYMENT ||
                this.$route.name === CONSTANTS.DRAFT_ONE_TIME_SUPPLIER_PAYMENT_FORM
        },
        lastDateOfMonth() {
            //For invoice dates, need to pass maxDate which is allowed till end of current month.
            const endOfMonth = moment().clone().endOf('month').format('YYYY-MM-DD');
            return endOfMonth
        },
        notLoadingOnPreviewPage() {
            return this.activeTabIndex == 2 ? true : !this.isLoading
        },
        companyCodeAndNameList() {
            let companyCodeAndNameList = []
            this.adminDataList.companyCodeList.forEach((company, index) => {
                companyCodeAndNameList.push({
                    value: `${index + 1}`,
                    text: company.companyCode + ' - ' + company.companyName
                })
            })
            return companyCodeAndNameList
        },
    },
    mounted() {
        //disable autofill for companyCodeAndNameList dropdown.
        this.disableAutofill('companyCodeAndNameList')
        this.initializeTooltip()
    },
    filters: {
        naIfEmpty: function(value) {
            return value ? value : "N/A";
        },
        naIfDateAllZerosOrEmpty: function(value) {
            if(value) {
                if(value === CONSTANTS.DATE_ALL_ZEROS)
                    return 'N/A'
                else
                    return value
            }
            return 'N/A'
        },
    },
    methods: {
        ...mapMutations(["setIsLoading",
            "setErrorMessage",
            "setIsFormDataLoaded",
            "setNonPOPaymentData",
            "setOneTimeSupplierPayment",
            "setPoBasedPaymentData",
            "setFormValidationErrors",
            "setAdvPOBasedPaymentData",
            "setIsInvalidPoNumber",
            "setInvoiceSubmissionData","setIsContinueDraftClicked","setIsInvoicesAndDraftsCached","setBankDetailsDropdownValues","setAdminDataList","setFormattedInvoices"]),
        ...mapActions(["populateUserInfo","submitPOBasedPaymentData","submitNonPOBasedPaymentData","submitOneTimeSupplierPaymentData","fetchAllAdminDataRequiredList"]),
        isValidString(str) {
            return str && str !== undefined && str !== '' && str.length > 0
        },
        updateSupplierAutoCompleteData(supplierData){
            this.supplierAutoCompleteObject = {}
            this.supplierAutoCompleteObject.supplierId = this.isValidString(supplierData.supplierId) ? supplierData.supplierId : ``
            this.supplierAutoCompleteObject.supplierName = this.isValidString(supplierData.supplierName) ? supplierData.supplierName : ``
            this.supplierAutoCompleteObject.companyCode = this.isValidString(supplierData.companyCode) ? supplierData.companyCode : ``
            return this.supplierAutoCompleteObject
        },
        async getAllRequiredData(){
            //The below check is to ensure that while the Ph-2 forms are loaded for the 1st time, the data is fetched from the API , else we dont call the API and use the stored data.
            if (!this.adminDataListExists())
            {
                await this.fetchAllAdminDataRequiredList(false);
            }
        },
        adminDataListExists() {
            return (this.adminDataList &&
                this.adminDataList.companyBusinessPlaceList.length !== 0 &&
                this.adminDataList.companyCodeList.length !== 0 &&
                this.adminDataList.countryList.length !== 0 &&
                this.adminDataList.countryStateList.length !== 0 &&
                this.adminDataList.currencyList.length !== 0 &&
                this.adminDataList.expenseTypeCodeOptions.length !== 0 &&
                this.adminDataList.expenseTypeTextOptions.length !== 0
            )
        },
        redirectToNotFound() {
            const notFoundURL = CONSTANTS.EH_URL + '/404'
            window.location.replace(notFoundURL)
        },
       autoPopulateBankInformation(uniqueNumberPerForm,formType){
            this.setIsLoading(true)
               api.getPOSupplierDetailsById(uniqueNumberPerForm,formType).then(res=>{
                   if (res.data && res.data.data.fetchWebformDetail && res.data.data.fetchWebformDetail.webformResponse && res.data.data.fetchWebformDetail.webformResponse.bankDetails){
                       this.setBankDetailsDropdownValues(res.data.data.fetchWebformDetail.webformResponse.bankDetails)
                   }else{
                       this.setBankDetailsDropdownValues([]);
                   }
               }).finally(()=>{
                   this.setIsLoading(false)
               })
        },
        clearBankData(bankData){
            bankData.bankName = ""
            bankData.bankAccountHolderName = ""
            bankData.bankNumber = ""
            bankData.bankSwiftCode = ""
            bankData.bankIBAN = ""
            bankData.bankCountry = ""
            bankData.bankAccountNumber = ""
        },
        saveDraftOneTimeSupplierPaymentRequest(draft){
            //Deep copy existing object since if user picks to continue draft, they should still see bank information
            let draftObj = JSON.parse(JSON.stringify(this.oneTimeSupplierPayment))
            draftObj = this.deletePaymentDataForDrafts(draftObj)

            this.submitOneTimeSupplierPaymentData({
                data: draftObj,
                isDraft:draft
            })
                .finally(() => {
                    if (!this.errorMessage && draft) {
                        this.showDraftMessage()
                    }else {
                        this.showFailureNotification()
                    }
                })
        },
        saveDraftPOBasedPaymentRequest(draft){
            //Deep copy existing object since if user picks to continue draft, they should still see bank information
            let draftObj = JSON.parse(JSON.stringify(this.poBasedPaymentData))
            draftObj = this.deletePaymentDataForDrafts(draftObj)

            this.submitPOBasedPaymentData({
                data: draftObj,
                isDraft:draft
            })
                .finally(() => {
                    if (!this.errorMessage && draft) {
                        this.showDraftMessage()
                    }else {
                        this.showFailureNotification()
                    }
                })
        },
        showDraftMessage() {
                swal
                    .fire({
                        title: `Draft saved`,
                        html: `Drafts can be viewed on Invoices tab in Supplier central`,
                        footer:
                            `<span class="text-muted swal-footer-text">Note: Bank information will not be saved to the drafts</span>`,
                        showCancelButton: true,
                        allowOutsideClick: false,
                        allowEscapeKey: false,
                        confirmButtonText: "Show Drafts",
                        cancelButtonText: "Continue Draft",
                        focusConfirm: false,
                        customClass: {
                            confirmButton: "flat-btn primary-blue-btn btn mb-3",
                            cancelButton: "flat-btn gray-btn cancel-btn btn mb-3",
                        },
                        buttonsStyling: false,
                    })
                    .then((result) => {
                        if (result.isConfirmed) {
                            //resetting PO, NONPO & One-Time Supplier Payment data to clear the form when Once user saves draft, and revisits the same form (without opening the draft, i.e → a fresh form), we dont see stale values
                            this.resetPOBasedPaymentData();
                            this.resetNonPOPaymentData()
                            this.resetOneTimeSupplierPaymentData()
                            this.setIsContinueDraftClicked(false)
                            this.setIsInvoicesAndDraftsCached(true)
                            let formDisplayText = CONSTANTS.INVOICE_FORM_TYPE.find(form => (form.eligibleFormTypes.includes(this.$route.meta.tab))).formDisplayText
                            this.$hhMixpanel.trackEvent(`Draft saved for form: ${formDisplayText}`);
                            this.$router.push({path: CONSTANTS.DRAFT_DASHBOARD_OPTIONAL_ROUTE})
                        }else{
                            this.setIsContinueDraftClicked(true)
                            this.setIsFormDataLoaded(true)
                            if (this.$route.meta.tab === CONSTANTS.PO_BASED_PAYMENT_FORM || this.$route.meta.tab === CONSTANTS.DRAFT_PO_BASED_PAYMENT_FORM) {
                                this.validateAndReplaceRoute(CONSTANTS.DRAFT_PO_BASED_PAYMENT_FORM)
                            } else if (this.$route.meta.tab === CONSTANTS.NON_PO_PAYMENT_FORM || this.$route.meta.tab === CONSTANTS.DRAFT_NON_PO_BASED_PAYMENT_FORM) {
                                this.validateAndReplaceRoute(CONSTANTS.DRAFT_NON_PO_BASED_PAYMENT_FORM)
                            } else if (this.$route.meta.tab === CONSTANTS.ONE_TIME_SUPPLIER_PAYMENT || this.$route.meta.tab === CONSTANTS.DRAFT_ONE_TIME_SUPPLIER_PAYMENT_FORM) {
                                this.validateAndReplaceRoute(CONSTANTS.DRAFT_ONE_TIME_SUPPLIER_PAYMENT_FORM)
                            }
                        }
                    });
        },
        validateAndReplaceRoute(routeName){
            /* eslint-disable no-console */
            this.$router.replace({
                name: routeName,
                params: { id: this.draftId },
            })
                .catch((ex) => {
                    if (ex.name !== 'NavigationDuplicated') {
                        console.error(ex)
                    }
                });
        },
        showFailureNotification() {
            swal
                .fire({
                    title: `Error`,
                    icon: "error",
                    html: CONSTANTS.ERROR_MESSAGE,
                    confirmButtonText: "Ok",
                    focusConfirm: false,
                    customClass: {
                        confirmButton: "flat-btn submit-btn btn",
                    },
                    buttonsStyling: false,
                })
                //We would like the user to re-try (in case the api was down for a bit)
                //If user presses Ok, we do nothing.
                .then(() => {});
        },
        saveDraftNonPOBasedPaymentRequest(draft){
            //Deep copy existing object since if user picks to continue draft, they should still see bank information
            let draftObject = JSON.parse(JSON.stringify(this.nonPOPaymentData))
            draftObject = this.deletePaymentDataForDrafts(draftObject)

            this.submitNonPOBasedPaymentData({
                data: draftObject,
                isDraft:draft
            })
                .finally(() => {
                    if (!this.errorMessage && draft) {
                        this.showDraftMessage()
                    }else {
                        this.showFailureNotification()
                    }
                })
        },
        deletePaymentDataForDrafts(draftObj) {
            delete draftObj.bankName;
            delete draftObj.bankCountry;
            if (draftObj.paymentType === CONSTANTS.MODE_OF_PAYMENT.BANK_TRANSFER){
                delete draftObj.bankAccountHolderName;
            }
            delete draftObj.bankAccountNumber;
            delete draftObj.bankIBAN;
            delete draftObj.bankNumber;
            delete draftObj.bankSwiftCode;
            delete draftObj.formType;
            delete draftObj.attachmentUrl;
            return draftObj
        },
        initializeTooltip() {
            /* eslint-disable no-undef */
            this.$nextTick(function() {
                $('[data-toggle="tooltip"]').tooltip();
            });
        },
        resetInvoiceAndCreditMemoData(form) {
            if(this[form].creditMemo) {
                this[form].invoiceReferenceForCreditMemo = ''
            }
        },
        formAttachmentsExist(form) {
            return this[form].attachments && this[form].attachments.length > 0
        },
        formatAmount({event, currencyValue, currencyText, form, item}) {
            //This  method takes in currency by text or value (depending on how its called)
            // and adjusts decimal value of the corresponding input field.
            //Currently this method is being used on blur.

            let allowedDecimals = 0
            if(currencyValue) {
                allowedDecimals = this.adminDataList.currencyList.find(currency => currency.value === currencyValue).decimal
            } else if(currencyText) {
                allowedDecimals = this.adminDataList.currencyList.find(currency => currency.text === currencyText).decimal
            }
            let targetText = event.target.value
            if(targetText && targetText.length > 0 && (this.isValidNumber(targetText))) {
                this[form][item] = this.updateAmount(targetText, allowedDecimals)
            }
        },
        validateTotalAmount(invoiceData,copiedInvoiceData){
            let totalAmount = 0
            if(this.getFloatValue(copiedInvoiceData ? invoiceData.invoicedAmount : invoiceData.netAmount) > 0){
                totalAmount += this.getFloatValue(copiedInvoiceData ? invoiceData.invoicedAmount : invoiceData.netAmount)
                if(this.getFloatValue(invoiceData.taxAmount) > 0) {
                    totalAmount += this.getFloatValue(invoiceData.taxAmount)
                }
            }

            let totalAllowedDecimals = this.allowedDecimals(invoiceData,copiedInvoiceData)

            return this.updateAmount(totalAmount, totalAllowedDecimals)
        },
        allowedDecimals(invoiceData,copiedInvoiceData) {
            let allowedDecimals = 0;
            if (copiedInvoiceData){
                allowedDecimals = invoiceData.currency ?
                    this.adminDataList.currencyList.find(currency => currency.value === invoiceData.currency).decimal : 2
            }else{
                allowedDecimals = invoiceData.currency ?
                    this.adminDataList.currencyList.find(currency => currency.value === invoiceData.currency).decimal : 2
            }
            return allowedDecimals
        },
        getFloatValue(number) {
            if(number && (parseFloat(number) > 0 || parseFloat(number) < 0))
            return parseFloat(number.toString().replace(/,/g, ''))
        },
        updateAmount(number, allowedDecimals) {
            if(number && this.isValidNumber(number) && (allowedDecimals || allowedDecimals === 0)) {
                return Number(parseFloat(number.toString().replace(/,/g, ''))).toLocaleString(CONSTANTS.EN_US_LOCALE, {minimumFractionDigits: allowedDecimals})
            } else {
                return 0
            }
        },
        isValidNumber(number) {
          return (parseFloat(number) > 0 || parseFloat(number) < 0)
        },
        setInvoiceAmountInvalid(value) {
            this.isInvoiceAmountInvalid = value
        },
        setTaxAmountInvalid(value) {
            this.isTaxAmountInvalid = value
        },
        navigateToHome() {
            this.setIsFormDataLoaded(false)
            this.setFormValidationErrors([])
            let currentRoute = this.$router.currentRoute.name
            let resetFormMethod = CONSTANTS.FORM_ROUTE_MAP.find(data => data.currentForm === currentRoute).resetFormMethod
            this[resetFormMethod]()
            this.$router.push({path: "/"}).then(() => {})
        },
        navigateToInvoices() {
            this.setIsFormDataLoaded(false)
            this.setFormValidationErrors([])
            let currentRoute = this.$router.currentRoute.name
            let resetFormMethod = CONSTANTS.FORM_ROUTE_MAP.find(data => data.currentForm === currentRoute).resetFormMethod
            this[resetFormMethod]()
            //Setting invoices to empty so that data is refreshed on invoices component and scrolled to Invoice submission status section.
            this.setFormattedInvoices([])
            this.$router.push({path: CONSTANTS.INVOICE_SUBMISSION_TRACKER_OPTIONAL_ROUTE})
        },
        resetPOBasedPaymentData(){
            let poBasedPaymentObj = {
                creditMemo: false,
                poNumber: '',
                companyCode: "",
                companyCodeText: '',
                supplierNumber: "",
                supplierName: "",
                invoiceDate: "",
                paymentDueDate: "",
                invoiceNumber: "",
                invoiceReferenceForCreditMemo: "",
                currency: "",
                invoicedAmount: "",
                assignment: "",
                docHeaderText: "",
                paymentTypeDescription: "",
                specialInstructions: "",
                paymentType: "",
                bankAccountHolderName: "",
                bankName: "",
                bankCountry: "",
                bankAccountNumber: "",
                bankIBAN: "",
                bankNumber: "",
                bankSwiftCode: "",
                directDebitDeductionDate: '',
                payrollPaymentDate: '',
                boletoSlipExpiryDate: ''

            }
            this.setPoBasedPaymentData(poBasedPaymentObj)
        },
        resetOneTimeSupplierPaymentData(){
            let oneTimeSupplierPaymentObj = {
                autoInputFlag: false,
                bankAccountHolderName: '',
                bankAccountNumber: '',
                bankNumber: '',
                bankIBAN: '',
                bankCountry: '',
                bankName: '',
                bankSwiftCode: '',
                city: '',
                companyCode: '',
                companyCodeText: '',
                country: '',
                currency: '',
                houseNumber: '',
                invoicedAmount: '',
                invoiceDate: '',
                invoiceNumber: '',
                paymentDueDate: '',
                paymentTypeDescription: '',
                poNumber: '',
                postalCode: '',
                region: '',
                specialInstructions: '',
                street: '',
                supplierName: '',
                supplierNumber: '',
                supplierTaxId: '',
                boletoSlipExpiryDate: ''
            }
            this.setOneTimeSupplierPayment(oneTimeSupplierPaymentObj)
        },

        resetAdvPOBasedPaymentData() {
            let advPOBasedPaymentData = {
                bankAccountHolderName: '',
                bankAccountNumber: '',
                bankNumber: '',
                bankCountry: '',
                bankIBAN: '',
                bankName: '',
                bankSwiftCode: '',
                businessReason: '',
                companyCode: '',
                companyCodeText: '',
                currency: '',
                invoicedAmount: '',
                invoiceDate: '',
                paymentDueDate: '',
                invoiceNumber: '',
                poNumber: '',
                specialInstructions: '',
                supplierName: '',
                supplierNumber: '',
                boletoSlipExpiryDate: ''
            }
            this.setAdvPOBasedPaymentData(advPOBasedPaymentData)
        },

        resetNonPOPaymentData() {
            let nonPOPaymentData = {
                creditMemo: false,
                assignment: '',
                bankAccountHolderName: '',
                bankAccountNumber: '',
                bankNumber: '',
                bankCountry: '',
                bankIBAN: '',
                bankSwiftCode: '',
                bankName: '',
                companyCode: '',
                companyCodeText: '',
                currency: '',
                directDebitDeductionDate: '',
                deliveryLocation: '',
                docHeaderText: '',
                expenseType: '',
                expenseTypeCode: '',
                invoicedAmount: '',
                invoiceDate: '',
                invoiceDescription: '',
                invoiceItems: [],
                invoiceNumber: '',
                netAmount: '',
                paymentDueDate: '',
                paymentType: '',
                payrollPaymentDate: '',
                invoiceReferenceForCreditMemo: '',
                requesterEmail: '',
                specialInstructions: '',
                supplierName: '',
                supplierNumber: '',
                taxAmount: '',
                totalAmount: '',
                unmatchedAmount: '',
                boletoSlipExpiryDate: ''
            }
            this.setNonPOPaymentData(nonPOPaymentData)
        },
        resetInvoiceSubmissionData() {
            let invoiceSubmissionData = {
                attachments: [],
                companyCode: '',
                companyCodeText: '',
                requesterEmail: ''
            }
            this.setInvoiceSubmissionData(invoiceSubmissionData)
        },
        onInvoiceUploaded(attachments, form){
            this.showAttachmentsError = false
            this[form].attachments = attachments;
        },
        removeAttachmentFileSizes(form) {
          if(form && form.attachments && form.attachments.length > 0) {
              form.attachments.forEach(attachment => {
                  delete attachment.fileSize
              })
          }
          return form
        },
        onInvoiceDeleted(removeAttachment, form){
            var existingAttachments = this[form].attachments;
            this[form].attachments = existingAttachments.filter( existingAttachment => existingAttachment.fileId != removeAttachment.fileId);
            this.formAttachmentsExist(form) ? this.showAttachmentsError = false : this.showAttachmentsError = true
        },
        validateAndSetCurrentTab(tab) {
            window.scrollTo(0,0)
            this.$validator.detach("oneTimeSupplierPayment.poNumber");
            this.$validator.detach("nonPOPaymentData.companyCode");
            this.$validator.detach("poBasedPaymentData.poNumber");
            this.$validator.detach("nonPOPaymentData.companyCode");
            this.$validator.validateAll().then((result) => {
                if(result) {
                    this.$emit('setCurrentTab', tab)
                }
             })
        },
        getTextValue(list, value) {
            let returnValue = ''
            if(value) {
               returnValue =  list.find(item => item.value === value).text
            }
            return returnValue.toString()
        },
        //In case of PDF invoice submission, we directly route to SAP and do not use async approach.
        buildMessageString(returnMessages, isAsyncSubmission = true) {
            let messages = []
            if(isAsyncSubmission) {
                returnMessages.responseMessages.forEach(message => {
                    messages.push(`${message}`)
                })
            } else {
                returnMessages.forEach(message => {
                    messages.push(`${message.message}`)
                })
            }

            return messages
        },
        launchSuccessModal(message, event, formType = null) {
            swal.fire({
                title: `Submitted!`,
                footer:
                    `<span class="text-muted swal-footer-text">${FORM_LABELS.SUCCESS_FOOTER_NOTE}</span>`,
                allowOutsideClick: false,
                allowEscapeKey: false,
                html: formType === CONSTANTS.INVOICE_SUBMISSION_BASED_API_FORM_TYPE ? message + `<br><br><span class="font-italic">${FORM_LABELS.INVOICE_SUBMISSION_MODAL_ADDITIONAL_TEXT}</span>` : message,
                showConfirmButton: true,
                focusConfirm: false,
                customClass: {
                    confirmButton: "flat-btn primary-blue-btn btn mb-3",
                    content:"sweet-alert-content"
                },
                buttonsStyling: false
            }).then((result) => {
                if(result.isConfirmed) {
                    this.$hhMixpanel.trackEvent(event)
                    this.navigateToInvoices()
                }
            })
        },
        launchFailedModal(message, event) {
            swal.fire({
                title: `Error`,
                allowOutsideClick: false,
                allowEscapeKey: false,
                html: message,
                showConfirmButton: true,
                focusConfirm: false,
                customClass: {
                    confirmButton: "flat-btn primary-blue-btn btn mb-3",
                    content:"sweet-alert-content"
                },
                buttonsStyling: false
            }).then((result) => {
                if(result.isConfirmed) {
                    this.$hhMixpanel.trackEvent(event)
                }
            })
        },
        disableAutofill(id) {
            let element = document.getElementById(id)
                if(element) {
                    element.autocomplete = 'eh-autofill-off'
                }
        },
        getUserDetail(userId) {
            return this.userData(userId)
        },
        isValidCopyData(response) {
            return response && response.data && response.data.data && response.data.data.fetchInvoiceDetailById && response.data.data.fetchInvoiceDetailById.webformResponse
        },
        async fetchCopiedInvoiceData() {
            this.setIsLoading(true)
            let response = {}
            try {
                if( this.$route.name === CONSTANTS.COPY_PO_BASED_PAYMENT_FORM ){
                    response = await api.getCopyDataFromInvoicesDashboard(this.$route.params.docId, CONSTANTS.PO_BASED_API_FORM_TYPE)
                    if (this.isValidCopyData(response) && response.data.data.fetchInvoiceDetailById.webformResponse.invoiceDetail){
                        this.copiedInvoiceData = response.data.data.fetchInvoiceDetailById.webformResponse.invoiceDetail
                    }else{
                        this.copiedInvoiceData = {}
                    }
                }else if (this.$route.name === CONSTANTS.COPY_NON_PO_BASED_PAYMENT_FORM ){
                    response = await api.getCopyDataFromInvoicesDashboard(this.$route.params.docId, CONSTANTS.NON_PO_BASED_API_FORM_TYPE)
                    if (this.isValidCopyData(response)){
                        this.copiedInvoiceData = response.data.data.fetchInvoiceDetailById.webformResponse
                    }
                    else{
                        this.copiedInvoiceData = {}
                    }
                }
            } catch (e) {
                this.setErrorMessage(CONSTANTS.ERROR_MESSAGE)
            } finally {
                this.setIsLoading(false)
            }
        },
        async getSupplierSubmissionStatusById(id) {
            let count = 0
            let response = ''
            do {
                try {
                    response = await api.fetchSupplierSubmissionStatusById(id)
                    this.supplierRequestIsPendingAtSAP(response) ? await new Promise(r => setTimeout(r, CONSTANTS.WEBFORM_SUBMISSION_POLLING.RETRY_INTERVAL)) : ''
                    count++
                } catch(e) {
                    console.error("exception: ", e)
                }
            } while(count < CONSTANTS.WEBFORM_SUBMISSION_POLLING.RETRY_COUNT && this.supplierRequestIsPendingAtSAP(response))
        return response.data.data.fetchWebformSubmissionStatusById
        },
        supplierRequestIsPendingAtSAP(response) {
            return (response && response.data.data.fetchWebformSubmissionStatusById.status === CONSTANTS.WEBFORM_SUBMISSION_STATUS.PUBLISHED)
        }
    }
}

